import InviteRoute from './InviteRoute'

export default InviteRoute
